import i18n from "lib/i18n";
import moment from "moment";
import { template } from "lodash";
import { View } from "backbone";
/* eslint-disable
    func-names,
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CustomDateRangeConfirmationView;
export default CustomDateRangeConfirmationView = (function () {
  CustomDateRangeConfirmationView = class CustomDateRangeConfirmationView extends View {
    static initClass() {
      this.prototype.className = "custom-date-range-confirmation-view";
      this.prototype.events = {
        "click .cancel": "_handleCancel",
        "click .done": "_handleDone",
      };

      this.prototype.template = template(`\
<div class="calendar-view-header">
  <a href="#" class="cancel"><%= i18n.t('calendar.button.cancel') %></a>
  <a href="#" class="done"><%= i18n.t('calendar.button.done') %></a>
</div>
<div class="selected-dates">
  <h2><%= i18n.t('calendar.label.ranges.starting_from') %></h2>
  <div class="start-date"><%- startDate %></div>

  <h2><%= i18n.t('calendar.label.ranges.ending_at') %></h2>
  <div class="end-date"><%- endDate %></div>
</div>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);

      this.startDate = options.startDate;
      this.endDate = options.endDate;

      this.render();

      this.startDateEl = this.$el.find(".start-date");
      return this.endDateEl = this.$el.find(".end-date");
    }

    render() {
      return this.$el.html(this.template({
        startDate: this.startDate,
        endDate: this.endDate,
      }),
      );
    }

    setStartDate(date) {
      return this.startDateEl.html(moment(date).format("MMMM Do YYYY"));
    }

    setEndDate(date) {
      return this.endDateEl.html(moment(date).format("MMMM Do YYYY"));
    }

    _handleDone(event) {
      event.preventDefault();
      return this.trigger("done");
    }

    _handleCancel(event) {
      event.preventDefault();
      return this.trigger("cancel");
    }
  };
  CustomDateRangeConfirmationView.initClass();
  return CustomDateRangeConfirmationView;
}());
